/** Pharmacist surface shell (Rx-01..Rx-17). Responsive: sidebar + mobile bottom nav; the name
 *  top right opens the account panel (profile, notifications, password). */

import { AccountPanel } from "../../components/AccountPanel";
import { ListIcon, RoleLayout, UploadIcon } from "../../components/RoleLayout";

export function PharmacistLayout() {
  return (
    <RoleLayout
      title="Pharmacy"
      profile={<AccountPanel />}
      nav={[
        // An order opens at /orders/:id: the queue it came from stays lit (RESP-04).
        { to: "/staff/pharmacist/queue", label: "Order queue", short: "Queue", icon: <ListIcon />, also: ["/staff/pharmacist/orders"] },
        { to: "/staff/pharmacist/uploads", label: "Digitise", short: "Digitise", icon: <UploadIcon /> },
      ]}
    />
  );
}
